import React, { Component } from 'react'
import styles from './style.module.less'
import Upload from '@common/Upload'
import { CloseCircleFilled, ExclamationCircleFilled } from '@ant-design/icons'
import { Input, Button } from 'hljd'
import { observer } from 'mobx-react'

@observer
export default class extends Component {
  render() {
    const { store, indexStore } = this.props

    const {
      type,
      pending_status,
      p_params: { p_realname, p_certify, p_certify_front, p_certify_back },
      c_params: {
        c_realname,
        c_certify,
        c_certify_front,
        c_certify_back,
        c_company_license,
        c_company_code,
        c_company_name
      },
      fail_reason
    } = store

    let style = { marginLeft: 140 }

    return (
      <div>
        {pending_status == 1 && (
          <div className={styles.checkTip}>
            <ExclamationCircleFilled />&nbsp;审核中！审核结束后，您将收到我们的通知。
          </div>
        )}

        {pending_status == 2 &&
          fail_reason && (
            <div className={styles.checkTip}>
              <p>
                <CloseCircleFilled />&nbsp;实名认证审核未通过
              </p>
              <p className={styles.reason}>原因：{fail_reason}</p>
              <a
                onClick={() =>
                  window.open(
                    '//www.hunliji.com/p/wedding/Public/wap/m/audit-rules/index.html',
                    '',
                    `height=667, width=375, top=${(window.screen.height - 667) /
                      2},left=${(window.screen.width - 375) / 2}`
                  )
                }
              >
                查看审核标准
              </a>
            </div>
          )}

        <div className={styles.box}>
          <div
            className={`${styles.item} ${styles.clearfix}`}
            style={{ ...style }}
          >
            <div className={styles.clearfix}>
              <div className={styles.label}>
                <i>*</i>选择认证类型
              </div>
              <div
                className={
                  type == '2'
                    ? `${styles.verifyType} ${styles.focus}`
                    : `${styles.verifyType}`
                }
                onClick={store.changeType('2')}
              >
                有营业执照
              </div>

              <div
                style={{ marginLeft: 20 }}
                className={
                  type == '1'
                    ? `${styles.verifyType} ${styles.focus}`
                    : `${styles.verifyType}`
                }
                onClick={store.changeType('1')}
              >
                无营业执照
              </div>
            </div>

            <p className={styles.tips}>
              认证类型为「有营业执照」的团队，审核通过后将在用户端显示&nbsp;<img src="https://qnm.hunliji.com/o_1dijru7udhb2ta4aeu15bv1c8d9.png" />&nbsp;标志；
            </p>
          </div>

          {type == '1' && (
            <div>
              <div
                className={`${styles.item} ${styles.clearfix}`}
                style={{ ...style }}
              >
                <div className={styles.label}>
                  <i>*</i>真实姓名
                </div>
                <Input
                  size="large"
                  value={p_realname}
                  placeholder="请输入你的真实姓名"
                  style={{ width: 460, height: 44 }}
                  onChange={store.changeParams('p_realname')}
                />
              </div>

              <div
                className={`${styles.item} ${styles.clearfix}`}
                style={{ ...style }}
              >
                <div className={styles.label}>
                  <i>*</i>证件号码
                </div>
                <Input
                  size="large"
                  value={p_certify}
                  placeholder="请输入证件号码"
                  style={{ width: 460, height: 44 }}
                  onChange={store.changeParams('p_certify')}
                />
              </div>

              <div
                className={`${styles.item} ${styles.clearfix}`}
                style={{ ...style }}
              >
                <div className={styles.label}>
                  <i>*</i>证件正面
                </div>
                <Upload
                  showDelete
                  onDelete={store.removeCard('p_certify_front')}
                  link={p_certify_front ? p_certify_front : ''}
                  onOk={store.uploadCard('p_certify_front', true)}
                  style={{ width: 200, height: 200, float: 'left' }}
                  uptoken_url={'image_upload_token?from=timestamp_antileech'}
                />
                <div className={styles.example}>
                  <p className={styles.p1}>示例：</p>
                  <div className={styles.image}>
                    <img src="//qnm.hunliji.com/o_1b40mdafe154jstg1s9e1nemgojr.png?imageView2/2/h/160" />
                  </div>
                  <p className={styles.p2}>要求证件上的文字清晰可识别。</p>
                </div>
              </div>

              <div
                className={`${styles.item} ${styles.clearfix}`}
                style={{ ...style }}
              >
                <div className={styles.label}>
                  <i>*</i>证件反面
                </div>
                <Upload
                  showDelete
                  onDelete={store.removeCard('p_certify_back')}
                  link={p_certify_back ? p_certify_back : ''}
                  onOk={store.uploadCard('p_certify_back', true)}
                  style={{ width: 200, height: 200, float: 'left' }}
                  uptoken_url={'image_upload_token?from=timestamp_antileech'}
                />
                <div className={styles.example}>
                  <p className={styles.p1}>示例：</p>
                  <div className={styles.image}>
                    <img src="//qnm.hunliji.com/o_1b40mdcns1afr1n4p6ro19r8jk510.png?imageView2/2/h/160" />
                  </div>
                  <p className={styles.p2}>
                    1、要求证件上的文字清晰可见；
                    <br />
                    2、有效期在1个月以上。
                  </p>
                </div>
              </div>
            </div>
          )}
          {type == '2' && (
            <div>
              <div
                className={`${styles.item} ${styles.clearfix}`}
                style={{ ...style }}
              >
                <div className={styles.label}>
                  <i>*</i>法人姓名
                </div>
                <Input
                  size="large"
                  value={c_realname}
                  placeholder="请输入法人真实姓名"
                  style={{ width: 460, height: 44 }}
                  onChange={store.changeParams('c_realname')}
                />
              </div>

              <div
                className={`${styles.item} ${styles.clearfix}`}
                style={{ ...style }}
              >
                <div className={styles.label}>
                  <i>*</i>法人证件号码
                </div>
                <Input
                  size="large"
                  value={c_certify}
                  placeholder="请输入法人证件号码"
                  style={{ width: 460, height: 44 }}
                  onChange={store.changeParams('c_certify')}
                />
              </div>

              <div
                className={`${styles.item} ${styles.clearfix}`}
                style={{ ...style }}
              >
                <div className={styles.label}>
                  <i>*</i>法人证件正面
                </div>
                <Upload
                  showDelete
                  onDelete={store.removeCard('c_certify_front')}
                  link={c_certify_front ? c_certify_front : ''}
                  onOk={store.uploadCard('c_certify_front', true)}
                  style={{ width: 200, height: 200, float: 'left' }}
                  uptoken_url={'image_upload_token?from=timestamp_antileech'}
                />
                <div className={styles.example}>
                  <p className={styles.p1}>示例：</p>
                  <div className={styles.image}>
                    <img src="//qnm.hunliji.com/o_1b40mdafe154jstg1s9e1nemgojr.png?imageView2/2/h/116" />
                  </div>
                  <p className={styles.p2}>
                    1、要求证件上的文字清晰可见；
                    <br />
                    2、若上传复印件，复印件上需加盖与营业执照企业名称一致的公章。
                  </p>
                </div>
              </div>

              <div
                className={`${styles.item} ${styles.clearfix}`}
                style={{ ...style }}
              >
                <div className={styles.label}>
                  <i>*</i>法人证件反面
                </div>
                <Upload
                  showDelete
                  onDelete={store.removeCard('c_certify_back')}
                  link={c_certify_back ? c_certify_back : ''}
                  onOk={store.uploadCard('c_certify_back', true)}
                  style={{ width: 200, height: 200, float: 'left' }}
                  uptoken_url={'image_upload_token?from=timestamp_antileech'}
                />
                <div className={styles.example}>
                  <p className={styles.p1}>示例：</p>
                  <div className={styles.image}>
                    <img src="//qnm.hunliji.com/o_1b40mdcns1afr1n4p6ro19r8jk510.png?imageView2/2/h/116" />
                  </div>
                  <p className={styles.p2}>
                    1、要求证件上的文字清晰可见；
                    <br />
                    2、若上传复印件，复印件上需加盖与营业执照企业名称一致的公章；
                    <br />
                    3、身份证有效期在一个月以上。
                  </p>
                </div>
              </div>

              <div
                className={`${styles.item} ${styles.clearfix}`}
                style={{ ...style }}
              >
                <div className={styles.label}>
                  <i>*</i>企业名称
                </div>
                <Input
                  size="large"
                  value={c_company_name}
                  placeholder="请填写营业执照上的企业名称"
                  style={{ width: 460, height: 44 }}
                  onChange={store.changeParams('c_company_name')}
                />
              </div>

              <div
                className={`${styles.item} ${styles.clearfix}`}
                style={{ ...style }}
              >
                <div className={styles.label}>
                  <i>*</i>统一社会信用代码
                </div>
                <Input
                  size="large"
                  value={c_company_code}
                  placeholder="请输入统一社会信用代码，1个执照只能用于1个店铺"
                  style={{ width: 460, height: 44 }}
                  onChange={store.changeParams('c_company_code')}
                />
              </div>

              <div
                className={`${styles.item} ${styles.clearfix}`}
                style={{ ...style }}
              >
                <div className={styles.label}>
                  <i>*</i>企业营业执照
                </div>
                <Upload
                  showDelete
                  onDelete={store.removeCard('c_company_license')}
                  link={c_company_license ? c_company_license : ''}
                  onOk={store.uploadCard('c_company_license', true)}
                  style={{ width: 200, height: 200, float: 'left' }}
                  uptoken_url={'image_upload_token?from=timestamp_antileech'}
                />
                <div className={styles.example}>
                  <p className={styles.p1}>示例：</p>
                  <div className={styles.image}>
                    <img src="//qnm.hunliji.com/FuVFmzoSY1bijRkvn9pMpJYUuh67?imageView2/2/w/200" />
                  </div>
                  <p className={styles.p2}>
                    1、要求证件上的文字清晰可见；
                    <br />
                    2、复印件上需加盖与营业执照企业名称一致的公章。
                  </p>
                </div>
              </div>
            </div>
          )}
        </div>

        <div className={styles.btn}>
          <Button
            className={styles.button}
            type="primary"
            onClick={store.submit(type, indexStore)}
          >
            提交审核
          </Button>
          {/* <p style={{ marginTop: 6 }}>提交成功后进入支付宝实名认证服务</p> */}
        </div>
      </div>
    )
  }
}
